import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSale } from '../context/SaleContext';
import { Tag, X, Flame } from 'lucide-react';

const SaleBanner = () => {
  const { saleConfig, isBannerVisible, dismissBanner } = useSale();
  const location = useLocation();

  // Don't show sale banner on friends & family page (they get their own discount)
  if (!isBannerVisible || location.pathname === '/book-friends-family') return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-green-600 to-green-500 text-white py-2 px-4 z-[60]">
      <div className="container mx-auto flex items-center justify-center gap-2 pr-8">
        <Tag size={16} className="animate-pulse flex-shrink-0" />
        <p className="text-xs md:text-sm font-medium text-center">
          <span className="font-bold">{saleConfig.discount_percent}% OFF</span> {saleConfig.sale_title}
          <span className="hidden sm:inline"> - {saleConfig.sale_subtitle}</span>
          <span className="inline-flex items-center gap-1 ml-2 bg-white/20 px-2 py-0.5 rounded-full text-xs font-bold">
            <Flame size={12} className="text-yellow-300" />
            {saleConfig.remaining_slots} spots left
          </span>
        </p>
        <button
          onClick={dismissBanner}
          className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white p-1"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default SaleBanner;
